import {
  invalidatePaymentHistoryCache,
  invalidateSubscriptionsCache,
  invalidateRewardsCache,
  invalidatePreviousCleanersCache,
  invalidateSavedCardCache,
} from "./accountCache";
import { invalidatePackageCache } from "./packageCache";
import { invalidateBookingCache } from "./bookingCache";
import { invalidateAvailabilityCache } from "./availabilityCache";
import { invalidatePromoCache } from "./promoCache";
import { invalidatePackageDefsCache } from "./packageDefsCache";

/**
 * FE-3: Wipe all in-memory and localStorage caches that contain user-specific data.
 * Must be called whenever a user signs out to prevent the next session from seeing
 * stale data belonging to the previous user.
 */
export function clearAllUserCaches(): void {
  invalidatePaymentHistoryCache();
  invalidateSubscriptionsCache();
  invalidateRewardsCache();
  invalidatePreviousCleanersCache();
  invalidateSavedCardCache();
  invalidatePackageCache();
  invalidateBookingCache();
  invalidateAvailabilityCache();
  invalidatePromoCache();
  invalidatePackageDefsCache();
}
